import React, { useEffect, useState } from "react";
import { useMutation, useQuery } from "react-query";
import {
  deleteChatAgentQAFn,
  getChatAgentQAFn,
} from "../../../Services/ChatAgent";
import { Button, IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Delete, Edit } from "@mui/icons-material";
import { toast } from "react-toastify";

const ChatAgentQuestionAnswer = () => {
  const [faqList, setFaqList] = useState([]);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  // Example API call
  const { data, isLoading, refetch } = useQuery(["agentQA"], () =>
    getChatAgentQAFn({ store_id: localStorage.getItem("store_id") })
  );

  const AgentQA = data?.data?.data || [];

  const { mutate: DeleteQa } = useMutation(deleteChatAgentQAFn, {
    onSuccess: (res) => {
      if (res?.data?.response_code === 200) {
        toast.success(res?.data?.message);
        refetch();
      } else {
        toast.warn(res?.data?.message);
      }
    },
  });

  if (isLoading) {
    return <p className="text-center p-4">Loading...</p>;
  }

  return (
    <div className="  w-full  p-3">
      <div className=" flex  items-center  justify-end">
        <Button
          onClick={() => navigate("/chat-agent/question-answer/add")}
          variant="outlined"
          color="secondary"
        >
          Add
        </Button>
      </div>

      <div className="max-w-2xl  w-full mx-auto p-4 space-y-4  text-black">
        {AgentQA?.map((item, index) => (
          <div className=" flex justify-between items-center border border-gray-300 rounded-lg p-4 bg-white shadow-sm">
            <div key={index} className="  w-[90%]">
              <h3 className="font-bold text-lg">{item.question}</h3>

              <div className="mt-2">
                <p className="text-gray-700">{item.answer}</p>
              </div>

              {/* Keywords */}
              {item.keywords && (
                <div className="mt-2 flex flex-wrap gap-2">
                  {item.keywords.map((kw, i) => (
                    <span
                      key={i}
                      className="text-xs bg-gray-200 px-2 py-1 rounded"
                    >
                      #{kw}
                    </span>
                  ))}
                </div>
              )}
            </div>

            <div className=" flex flex-col  items-center justify-center  gap-3  w-[10%]">
              <IconButton
                onClick={() =>
                  DeleteQa({
                    qa_id: item?.id,
                    store: localStorage.getItem("store_id"),
                  })
                }
              >
                <Delete color="error" />
              </IconButton>

              <IconButton
                onClick={() =>
                  navigate("/chat-agent/question-answer/update", {
                    state: item,
                  })
                }
              >
                <Edit color="success" />
              </IconButton>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ChatAgentQuestionAnswer;
